import { render, staticRenderFns } from "./400.vue?vue&type=template&id=5121c8fa&scoped=true"
var script = {}
import style0 from "./400.vue?vue&type=style&index=0&id=5121c8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5121c8fa",
  null
  
)

export default component.exports